module.exports = __webpack_public_path__ + "img/cs-baseSucc-5.627bc257.jpg";